import React, { useState, useEffect } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import classes from './MoreOpportunitiesSection.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@/components/Button/Button';
import t from '@/utils/Language/OrganizationPage-translations';

const OpportunitiesMenuDropdown = ({ children }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMobileMenu = (e) => {
    setMenuOpen((prevState) => {
      if (prevState) {
        document.body.classList.remove(classes.noScroll);
      } else {
        document.body.classList.add(classes.noScroll);
      }
      return !prevState;
    });
  };

  // toggleMobileMenu is the only thing that clears noScroll, and it never runs if the component
  // goes away with the sheet open -- a client-side route change, or a keyed parent remounting
  // on navigation. Without this the next page loads unscrollable with nothing on screen to fix it.
  useEffect(() => {
    return () => document.body.classList.remove(classes.noScroll);
  }, []);

  return (
    <>
      <button onClick={toggleMobileMenu} className={classes.menuButton}>
        <FontAwesomeIcon icon={['fa', 'ellipsis-vertical']} />
      </button>
      {menuOpen && (
        <>
          <div className={classes.overlay} onClick={toggleMobileMenu}></div>
          <ListGroup className={classes.mobileActionMenu}>
            <ListGroup.Item className={classes.listItemDefaultClass}>
              <div className={classes.mobileActionMenuHeader}>
                <h5>{t('Opportunity')}</h5>
                <Button type="default" icon={{ style: 'fa', font: 'fa-xmark' }} onButtonClick={toggleMobileMenu} />
              </div>
            </ListGroup.Item>
            {React.Children.map(children, (child, index) => (
              <ListGroup.Item key={index} className={classes.listItemDefaultClass} onClick={toggleMobileMenu}>
                {child}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </>
      )}
    </>
  );
};

export default OpportunitiesMenuDropdown;
